import { faHome } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { Col, Nav, NavItem, NavLink } from 'reactstrap';

const LandingRightSideNavItem = () => {

  const { isLogged } = useSelector(state => state.auth);

  return <>
          <Nav navbar className="ml-auto">
            {!isLogged ?
              <>
                <NavItem>
                  <NavLink tag={Link} to="/authentication/login">
                    <span className={`d-lg-block`}>Iniciar sesión</span>
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink tag={Link} to="/register">
                    <span className={`d-lg-block`}>Regístrate</span>
                  </NavLink>
                </NavItem>
              </> :
              <>
                <NavItem>
                  <NavLink tag={Link} to="/dashboard/app">
                    <Col style={{whiteSpace: 'nowrap'}} className='d-flex' >
                      <FontAwesomeIcon className="float-left mr-2" icon={faHome} />
                      <span className={`d-lg-block`}>Ir al dashboard</span>
                    </Col>
                  </NavLink>
                </NavItem>
              </>
            }
          </Nav>
        </>
}

export default LandingRightSideNavItem;
